import { PropertyValueMap, unsafeCSS } from 'lit'
import { property, queryAssignedElements } from 'lit/decorators.js'
import { html } from 'lit/static-html.js'

import { DdsElement } from '../../internal/dds-hu-element'
import styles from './table.scss?inline'

/**
 * Data table component.
 * @element dap-ds-table
 * @title - Table
 *
 * @slot - The default slot. Accepts `dap-ds-table-row` elements.
 *
 * @cssprop --dds-table-border-width - Width of the table border. (default: var(--dds-border-width-base, 1px))
 * @cssprop --dds-table-border-color - Color of the table border. (default: var(--dds-border-neutral-subtle))
 * @cssprop --dds-table-border-radius - Border radius of the table. (default: var(--dds-radius-small, 4px))
 * @cssprop --dds-table-row-divider-color - Color of the divider between rows in mobile view. (default: var(--dds-border-neutral-subtle))
 */
export default class DapDSTable extends DdsElement {
  static tagName = 'dap-ds-table'

  /**@ignore */
  @queryAssignedElements() rows!: Array<HTMLElement>
  @property({ reflect: true }) public role = 'grid'
  /**If the table has mobile design */
  @property({ type: Boolean, reflect: true }) mobile = false

  /** The caption of the table */
  @property({ type: String }) caption = ''

  static readonly styles = unsafeCSS(styles)

  protected firstUpdated(
    _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>,
  ): void {
    this.rows.forEach((row, index) => {
      if (index === this.rows.length - 1) {
        row.toggleAttribute('last')
      }
    })

    this.setAttribute('aria-label', this.caption)
  }

  render() {
    return html`
      <caption class="caption" part="caption">
        ${this.caption}
      </caption>
      <slot></slot>
    `
  }
}
